import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { TransitViewGeneralInfoFormValues } from './validateTransitViewGeneralInfoForm';

interface TransitPlaceSectionProps {
  form: UseFormReturnType<TransitViewGeneralInfoFormValues>;
  editDisabled: boolean;
  isArrival: boolean;
}

export const TransitPlaceSection: React.FC<TransitPlaceSectionProps> = ({ form, editDisabled, isArrival }) => {
  const codelistSystems = useCodeListSystem({ isTransit: true });

  if (isArrival) {
    return null;
  }

  return (
    <Stack mb="xl" gap="xl">
      <Stack>
        <Title order={5} fw={600}>
          Place of loading
        </Title>
        <Grid>
          <Grid.Col span={3}>
            <MultiLangCodes
              {...form.getInputProps('Consignment.PlaceOfLoading.UNLocode')}
              label="UNLOCODE"
              system={codelistSystems}
              code="CL244"
              disabled={editDisabled}
            />
          </Grid.Col>
          <Grid.Col span={3}>
            <MultiLangCodes
              {...form.getInputProps('Consignment.PlaceOfLoading.country')}
              label="Country"
              system={codelistSystems}
              code="CountryCodesCommonTransit"
              disabled={editDisabled}
            />
          </Grid.Col>
          <Grid.Col span={3}>
            <TextInput {...form.getInputProps('Consignment.PlaceOfLoading.location')} label="Location" disabled={editDisabled} />
          </Grid.Col>
        </Grid>
      </Stack>

      <Stack>
        <Title order={5} fw={600}>
          Place of Unloading
        </Title>
        <Grid>
          <Grid.Col span={3}>
            <MultiLangCodes
              {...form.getInputProps('Consignment.PlaceOfUnloading.UNLocode')}
              label="UNLOCODE"
              system={codelistSystems}
              code="CL244"
              disabled={editDisabled}
            />
          </Grid.Col>
          <Grid.Col span={3}>
            <MultiLangCodes
              {...form.getInputProps('Consignment.PlaceOfUnloading.country')}
              label="Country"
              system={codelistSystems}
              code="CountryCodesCommonTransit"
              disabled={editDisabled}
            />
          </Grid.Col>
          <Grid.Col span={3}>
            <TextInput {...form.getInputProps('Consignment.PlaceOfUnloading.location')} label="Location" disabled={editDisabled} />
          </Grid.Col>
        </Grid>
      </Stack>
    </Stack>
  );
};
